package ru.chm.gradereport.ui.screens.course.sheet

internal data class GradeEditTarget(
    val studentId: String,
    val studentName: String,
    val homeworkId: String,
    val homeworkTitle: String,
    val maxScore: Double,
    val current: Double?,
)
